import React, { useEffect, useState } from "react";
import useDashboard from "./useHooks";

import {
  ClipboardCloseIcon,
  ExperiencesIcon,
  FamilyProfilesIcon,
  FrameIcon,
  LearnersIcon,
  LocationTickIcon,
  MagicStarIcon,
  StarIcon,
  StarsIcon,
} from "assets/images/dashboard/svg";
import { CITY_OPTIONS, ENGAGEMENT_LEVELS, INDUSTRY_TYPES } from "utils/helpers/enums/shared.enum";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";

const DashboardHome: React.FC = () => {
  const {
    getDashboard,
    getNumberOfAttendees,
    getNumberOfEventsInLocation,
    getNumberOfAmbassador,
    getNumberOfBusinesses,
    getNumberOfBusinessesInIndustry,
    getNumberOfBusinessesInEachMembership,
    getCancellationRateByHost,
    getAmbassadorInEachEngagementLevel,
    getAmbassadorInEachTier,
  } = useDashboard();


  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const [selectedValues, setSelectedValues] = useState<{
    [key: string]: string;
  }>({});

  const [dashboardData, setDashboardData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      await getDashboard(setDashboardData);
    };
    fetchData();
  }, []);



  const [dashboardNumberOfAttendees, setDashboardNumberOfAttendees] = useState<any>(null);
  const [numberOfEventsInLocation, setNumberOfEventsInLocation] = useState<any>(null);
  const [numberOfBusinesses, setNumberOfBusinesses] = useState<any>(null);
  const [numberOfBusinessesInIndustry, setNumberOfBusinessesInIndustry] = useState<any>(null);
  const [numberOfBusinessesInEachMembership, setNumberOfBusinessesInEachMembership] = useState<any>(null);
  const [cancellationRateByHost, setCancellationRateByHost] = useState<any>(null);
  const [ambassadorInEachEngagementLevel, setAmbassadorInEachEngagementLevel] = useState<any>(null);
  const [ambassadorInEachTier, setAmbassadorInEachTier] = useState<any>(null);
  const [ambassadorCounts, setAmbassadorCounts] = useState<any>(null);

  const [filters, setFilters] = useState<any>(null);

  const getAttendeesCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getNumberOfAttendees(
      setDashboardNumberOfAttendees,
      queryParams,
      setFilters
    );
  };

  const getEventLocation = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getNumberOfEventsInLocation(
      setNumberOfEventsInLocation,
      queryParams,
      setFilters
    );
  };

  const getAmbassadorCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getNumberOfAmbassador(
      setAmbassadorCounts,
      queryParams,
      setFilters
    );
  };

  const getBusinessCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getNumberOfBusinesses(
      setAmbassadorCounts,
      queryParams,
      setFilters
    );
  };

  const getBusinessesInIndustryCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getNumberOfBusinessesInIndustry(
      setNumberOfBusinessesInIndustry,
      queryParams,
      setFilters
    );
  };

  const getBusinessesInEachMembershipCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getNumberOfBusinessesInEachMembership(
      setNumberOfBusinessesInEachMembership,
      queryParams,
      setFilters
    );
  };

  const getCancellationRateByHostCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getCancellationRateByHost(
      setCancellationRateByHost,
      queryParams,
      setFilters
    );
  };

  const getAmbassadorInEachEngagementLevelCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getAmbassadorInEachEngagementLevel(
      setAmbassadorInEachEngagementLevel,
      queryParams,
      setFilters
    );
  };

  const getAmbassadorInEachTierCount = (filters: any) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
    };
    getAmbassadorInEachTier(
      setAmbassadorInEachTier,
      queryParams,
      setFilters
    );
  };











  useEffect(() => {
    if (!filters) return;
    if (Object.keys(filters).length > 0) {
      getAttendeesCount(filters);
    }

    if (filters.city) getEventLocation(filters);
    if (filters.filter) getAmbassadorCount(filters);
    if (filters.filter) getBusinessCount(filters);
    if (filters.industry) getBusinessesInIndustryCount(filters);
    if (filters.membership) getBusinessesInEachMembershipCount(filters);
    if (filters.filter) getBusinessesInEachMembershipCount(filters);
    if (filters.filter) getCancellationRateByHostCount(filters);
    if (filters.engagementLevel) getAmbassadorInEachEngagementLevelCount(filters);
    if (filters.tier) getAmbassadorInEachTierCount(filters);

  }, []);




  const handleSelectChange = (title: string, value: string) => {
    setSelectedValues((prev) => ({ ...prev, [title]: value }));

    if (title === "Family Profiles") {
      const updatedFilters = { filter: value };
      setFilters(updatedFilters);

      getNumberOfAttendees(
        setDashboardNumberOfAttendees,
        updatedFilters,
        setFilters
      );

    }

    if (title === "Locations") {
      const updatedFilters = { city: value };
      setFilters(updatedFilters);

      getNumberOfEventsInLocation(
        setNumberOfEventsInLocation,
        updatedFilters,
        setFilters
      );

    }

    if (title === "No. of Ambassadors") {
      const updatedFilters = { filter: value };
      setFilters(updatedFilters);

      getNumberOfAmbassador(
        setAmbassadorCounts,
        updatedFilters,
        setFilters
      );
    }
    if (title === "Total Businesses") {
      const updatedFilters = { filter: value };
      setFilters(updatedFilters);

      getNumberOfBusinesses(
        setNumberOfBusinesses,
        updatedFilters,
        setFilters
      );
    }

    if (title === "No. of Businesses in Industries") {
      const updatedFilters = { industry: value };
      setFilters(updatedFilters);

      getNumberOfBusinessesInIndustry(
        setNumberOfBusinessesInIndustry,
        updatedFilters,
        setFilters
      );
    }

    if (title === "How many Businesses in Each type of Membership") {
      const updatedFilters = { membership: value };
      setFilters(updatedFilters);

      getNumberOfBusinessesInEachMembership(
        setNumberOfBusinessesInEachMembership,
        updatedFilters,
        setFilters
      );
    }

    if (title === "Cancellation Rate of Events by Host") {
      const updatedFilters = { filter: value };
      setFilters(updatedFilters);

      getCancellationRateByHost(
        setCancellationRateByHost,
        updatedFilters,
        setFilters
      );
    }

    if (title === "Level of Engagement of Ambassadors") {
      const updatedFilters = { engagementLevel: value };
      setFilters(updatedFilters);

      getAmbassadorInEachEngagementLevel(
        setAmbassadorInEachEngagementLevel,
        updatedFilters,
        setFilters
      );
    }

    if (title === "How many Ambassadors in Each type of Tier") {
      const updatedFilters = { tier: value };
      setFilters(updatedFilters);

      getAmbassadorInEachTier(
        setAmbassadorInEachTier,
        updatedFilters,
        setFilters
      );
    }
  };



  const cards: any[] = [
    {
      title: "Experiences",
      value: dashboardData?.numberOfEvents ?? "0",

      description: "Popular Dates",
      icon: <ExperiencesIcon />,
      bgColor: "bg-[#EDF5FF]",
      dropdownOptions: [
        "Most Popular Dates",
        "Most Popular Times",
        "Most Popular Interest",
        "Most Popular Age Groups",
        "Most Popular Skill Level",
      ],
    },
    {
      title: "Family Profiles",
      value:
        dashboardNumberOfAttendees !== null
          ? dashboardNumberOfAttendees
          : dashboardData?.numberOfAttendees ?? "0",

      description: "All Time",
      icon: <FamilyProfilesIcon />,
      dropdownOptions: [
        "All Time",
        "Current Month",
        "Last Month",
        "Current Year",
        "Last Year",
      ],
      bgColor: "bg-[#EDF5FF]",
    },
    {
      title: "No. of Exceptional Learner Events",
      value: dashboardData?.numberOfEventsForExceptionalLearner ?? "0",
      description: "All Levels",
      icon: <LearnersIcon />,
      dropdownOptions: [
        "Exceptional Learners",
        "Appropriate for Age Level",
        "All Learners",
      ],
      bgColor: "bg-[#EDF5FF]",
    },
    {
      title: "Locations",
      value: numberOfEventsInLocation !== null
        ? numberOfEventsInLocation
        : dashboardData?.numberOfEventsInLocation ?? "0",
      description: "Select City",
      icon: <LocationTickIcon />,
      dropdownOptions: Object.values(CITY_OPTIONS),

      bgColor: "bg-[#FFF6E4]",
    },
    {
      title: "Cancellation by Attendees",
      value: dashboardData?.numberOfCancellations ?? "0",
      description: "All Time",
      icon: <ClipboardCloseIcon />,
      bgColor: "bg-[#FFEDED]",
      dropdownOptions: [
        "All Time",
        "Current Month",
        "Last Month",
        "Current Year",
        "Last Year",
      ],
    },
    {
      title: `Average Session Attended per Family (Current Month)`,
      value: "98%",
      description: "5",
      // icon: <FaStar />,
      dropdownOptions: ["5", "10", "15", "20", "25"],
      bgColor: "bg-[#FFEDFF]",
    },
    {
      title: `Attendee Survey Completion Rate (Feedback)`,
      value: "77%",
      icon: <StarIcon />,
      bgColor: "bg-[#EDF5FF]",
    },
    {
      title: "Attendee Satisfaction Rate (Overall Rating)",
      value: dashboardData?.attendeeSatisfaction ?? "0",
      description: "Overall Rating",
      icon: <MagicStarIcon />,
      bgColor: "bg-[#EDF5FF]",
    },
    {
      title: "Total Businesses",
      value: numberOfBusinesses !== null
        ? numberOfBusinesses
        : dashboardData?.numberOfBusinesses ?? "0",
      description: "All Time",
      icon: <StarsIcon />,
      bgColor: "bg-[#FFF6E4]",
      dropdownOptions: [
        "All Time",
        "Current Month",
        "Last Month",
        "Current Year",
        "Last Year",
      ],
    },
    {
      title: "No. of Businesses in Industries",
      value: numberOfBusinessesInIndustry !== null
        ? numberOfBusinessesInIndustry
        : dashboardData?.numberOfBusinessesInIndustry ?? "0",
      description: "Select Industry",
      icon: <StarsIcon />,
      dropdownOptions: Object.values(INDUSTRY_TYPES),
      bgColor: "bg-[#FFF6E4]",
    },
    {
      title: "How many Businesses in Each type of Membership",
      value: numberOfBusinessesInEachMembership !== null
        ? numberOfBusinessesInEachMembership
        : dashboardData?.numberOfBusinessesInEachMembership ?? "0",
      description: "Basic Membership",
      icon: <StarsIcon />,

      dropdownOptions: [
        "BASIC",
        "TIER_1",
        "TIER_2",
      ],
      bgColor: "bg-[#FFF6E4]",
    },
    {
      title: "Cancellation Rate of Events by Host",
      value: cancellationRateByHost !== null
        ? cancellationRateByHost
        : dashboardData?.cancelRateOfEventsByHost ?? "0",
      description: "All Time",
      icon: <ClipboardCloseIcon />,

      bgColor: "bg-[#FFEDED]",
      dropdownOptions: [
        "All Time",
        "Current Month",
        "Last Month",
        "Current Year",
        "Last Year",
      ],
    },
    {
      title: "How many Ambassadors in Each type of Tier",
      value: ambassadorInEachTier !== null
        ? ambassadorInEachTier
        : dashboardData?.numberOfAmbassadorInTier ?? "0",

      description: "Community Builder",
      icon: <FrameIcon />,
      dropdownOptions: [
        "tierOne",
        "tierTwo",
        "tierThree",
      ],
      bgColor: "bg-[#E2DAF8]",
    },
    {
      title: "No. of Ambassadors",
      value: ambassadorCounts !== null
        ? ambassadorCounts
        : dashboardData?.numberOfAmbassador ?? "0",
      description: "All Time",
      icon: <FrameIcon />,
      bgColor: "bg-[#E2DAF8]",
      dropdownOptions: [
        "All Time",
        "Current Month",
        "Last Month",
        "Current Year",
        "Last Year",
      ],
    },
    {
      title: "Level of Engagement of Ambassadors",
      value: ambassadorInEachEngagementLevel !== null
        ? ambassadorInEachEngagementLevel
        : dashboardData?.numberOfAmbassadorInEngagementLevel ?? "0",
      description: "Minimum",
      icon: <FrameIcon />,
      dropdownOptions: [
        "MINIMUM_5_6_HOURS_PER_MONTH",
        "MODERATE_10_15_HOURS_PER_MONTH",
        "HIGH_15_PLUS_HOURS_PER_MONTH",
      ],
      bgColor: "bg-[#E2DAF8]",
    },
    {
      title: "Top Ambassador Performer of the Month",
      value: "240",
      description: "Community Builder",
      icon: <FrameIcon />,
      bgColor: "bg-[#E2DAF8]",
      dropdownOptions: [
        "Community Builder ",
        "Community Advocate",
        "Community Leader",
      ],
    },
  ];

  return (
    <div className="">
      <h1 className="tex-2xl sm:text-[32px] text-primaryText font-bold">
        Dashboard
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 my-6">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`p-3 rounded-xl flex flex-col justify-between gap-2 relative h-[161px] ${card.bgColor}`}
          >
            <div className="flex justify-between items-start gap-2">
              <div className="text-sm text-primaryText font-semibold opacity-80">
                {card.title}
              </div>
              {card?.icon && (
                <div className="bg-white min-w-[50px] min-h-[50px] rounded-xl flex items-center justify-center">
                  {card?.icon}
                </div>
              )}
            </div>
            <div className="flex justify-between items-center">
              {card.value && (
                <div className="text-xl text-primaryText font-bold whitespace-nowrap">
                  {card.value}
                </div>
              )}
              <div className="text-sm text-primaryText bg-transparent  rounded-md focus:outline-none truncate max-w-[150px]">
                {card.dropdownOptions ? (
                  <select
                    className="px-1 py-1 text-base bg-transparent cursor-pointer appearance-noe rounded-md focus:outline-none"
                    value={selectedValues[card.title] || card.description}
                    onChange={(e) =>
                      handleSelectChange(card.title, e.target.value)
                    }
                  >
                    {card.dropdownOptions.map((option) => (
                      <option
                        className="outline-none focus:outline-none border-none"
                        key={option}
                        value={option}
                      >
                        {option}
                      </option>
                    ))}
                  </select>
                ) : (
                  card.description
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardHome;
